import React, { useEffect, useMemo, useState } from 'react';
import clsx from 'clsx';
import ScoreTypeView from '../../view';
import { useLocation, useRouteMatch } from 'react-router-dom';
import { MoreButton } from './styled';
import SportsAdsense from './AdSense';

/**
 * @description Map() 데이터를 순회하면서 toggles를 만들어줌
 * @param {*} view
 */
function initToggles(view) {
  let result = {};

  for (let [key] of view.entries()) {
    result[key] = true;
  }

  return result;
}

const ScoreDefaultWrapper = ({
  list,
  selectedGames,
  setSelectedGame,
  sportsType,
  handleToggleSetViewHotLayer,
  fromHome
}) => {
  const location = useLocation();
  const matches = useRouteMatch({
    path: location.pathname,
    strict: true,
    sensitive: true
  });

  const [toggles, setToggles] = useState(initToggles(list));
  const menuType = useMemo(() => {
    const type = location.pathname.split('/')[2];

    if (matches) {
      // When load Major Score in home page we need to set menuType to 'major'
      if (location.pathname.startsWith("/home")) {
        return 'major'
      }

      return type;
    } else {
      return undefined;
    }
  }, [matches, location]);

  useEffect(() => {
    setToggles(initToggles(list));
  }, [list]);

  const onClickToggle = (type) => {
    setToggles({
      ...toggles,
      [type]: !toggles[type]
    });
  };

  const generateScoreBox = useMemo(() => {
    let dom = [];
    let importedAdsense = false;

    for (let [key, value] of list.entries()) {
      const { hot } = value;

      if (sportsType === 'soccer' && !importedAdsense) {
        //dom.push(<SportsAdsense key={`adsense-${key}`} />);
        importedAdsense = true;
      }
      dom.push(
        <div
          className={clsx('section', hot || (key === 0 && !hot && 'hot'), (fromHome ? 'home' : ''))}
          key={key}
        >
          <div
            className="top"
            onClick={() =>
              !hot ? onClickToggle(key) : handleToggleSetViewHotLayer()
            }
          >
            <strong
              className={clsx(
                'tit',
                !hot && menuType === 'major' && value.sportsType + ' ic',
                hot && 'hot'
              )}
            >
              {value.league.shortName}
            </strong>
            {!hot ? (
              <button
                type="button"
                className={clsx('btn_oc', !toggles[key] && 'close')}
              >
                열기/닫기
              </button>
            ) : (
              <MoreButton>전체보기</MoreButton>
            )}
            {/* close 클래스 추가 */}
          </div>
          {toggles[key] && (
            <div className="list">
              {value.list.length > 0 &&
                value.list.map((item) => {
                  return (
                    <ScoreTypeView
                      key={item.id}
                      sportsType={
                        menuType === 'major' ? value.sportsType : sportsType
                      }
                      item={item}
                      setSelectedGame={setSelectedGame}
                      isSelected={selectedGames.some((id) => id === item.id)}
                      fromHome={fromHome}
                    />
                  );
                })}
            </div>
          )}
        </div>
      );

      if (
        (sportsType !== 'soccer' && !hot && !importedAdsense) ||
        (list.size === key + 1 && !importedAdsense)
      ) {
        //dom.push(<SportsAdsense key={`adsense-${key}`} />);
        importedAdsense = true;
      }
    }

    return dom;
  }, [list, toggles, menuType, onClickToggle, setSelectedGame, sportsType, fromHome]);

  return <>{generateScoreBox}</>;
};

export default ScoreDefaultWrapper;
